import Axios from 'axios';

import Cookies from 'universal-cookie';

import { cookiesRegister, typeCookie, typeCookieEmail, typeCookiePage, typeCookiePassw } from 'fixedData';

import { SetListPag } from 'interface/Page';
import { SetUserData } from 'interface/Users';

export function Access(type, reg_email, reg_pass, CallbackSuccess, CallbackError){
    const cookies = new Cookies();
    const data    = new FormData();

    data.append('type_post', 'logar');
    data.append('type', type);
    data.append('email', reg_email);
    data.append('password', reg_pass);

    Axios({
        url     : process.env.REACT_APP_API_URL + '/php/login.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        switch(response.data.type) {
            case 'conectado':
                    CallbackSuccess();
                    SetListPag('page', 'dashboard');
                    

                    cookies.set(typeCookie, 'dashboard', '/', cookiesRegister);
                    cookies.set(typeCookieEmail, response.data.email, '/', cookiesRegister);
                    cookies.set(typeCookiePassw, response.data.pass, '/', cookiesRegister);

                    // checked cookie page
                    if(cookies.get(typeCookiePage)){
                        let name_page = cookies.get(typeCookiePage);
                        SetListPag('currentPage', name_page);
                    }else {
                        cookies.set(typeCookiePage, 'index', '/', cookiesRegister);
                        SetListPag('currentPage', 'index');
                    }

                    SetUserData('id', response.data.id);
                    SetUserData('file', response.data.file);
                    SetUserData('name', response.data.name);
                    SetUserData('email', response.data.email);
                    SetUserData('access', response.data.access_type);
                    SetUserData('page', response.data.page);
                break;

            default:
                    CallbackError();
                    SetListPag('page', 'index');
                    SetListPag('currentPage', 'index');

                    cookies.set(typeCookie, 'index', '/', cookiesRegister);
                    cookies.remove(typeCookieEmail, "", '/', cookiesRegister);
                    cookies.remove(typeCookiePassw, "", '/', cookiesRegister);
                break;
        }

    }).catch((error)=>{
        CallbackError();
        SetListPag('page', 'index');
        SetListPag('currentPage', 'index');

        cookies.set(typeCookiePage, 'index', '/', cookiesRegister);
        cookies.remove(typeCookieEmail, "", '/', cookiesRegister);
        cookies.remove(typeCookiePassw, "", '/', cookiesRegister);
    })
}
